<div
  *ngIf="isVisible"
  [ngClass]="[
    'fixed z-50 p-3 border rounded-lg text-xs shadow-md',
    bgColor,
    borderColor
  ]"
  style="min-width: 210px; max-width: 350px; width: auto; transition: opacity 0.3s ease; opacity: 1; text-align: center; top: 20px; left: 50%; transform: translateX(-50%);"
>
  <div class="flex items-center">
    <img [src]="iconSrc" alt="Alert Icon" class="mr-2" />
    <div>
      <p class="font-medium leading-none" [innerHTML]="message | safeHtml"></p>
    </div>
  </div>
</div>
